import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import * as moment from 'moment';
import { Router, ActivatedRoute } from '@angular/router';
import { SearchService } from '../../../../services/search.service';

declare var $: any;
declare let ga: Function;
declare global {
  interface Window { dataLayer: any[];  }
}

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styles: ['./step-one.component.scss'],
  providers:[SearchService]
})
export class StepOneComponent implements OnInit {

  public form: FormGroup;
  public prod:any;
  public formPas: any;
  public daysInMonth:any;
  public monthsName:any = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
  public months:any;
  public years:any;
  public _moment: any;
  public totalPay;
  public typePassengers:any;
  public totalViajeros:any;
  public totalNormal:any;
  public totalIsic:any;
  public submitted:any = false;
  public flagActive:boolean = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private searchService: SearchService
    ) {
      console.log('send view page', this.router.url);
      if (typeof(ga) !== 'undefined') {
        ga('send', 'pageview', this.router.url);
        ga('send', {
          hitType: 'pageview',
          page: this.router.url
        });
      }

    if (!sessionStorage.getItem('product')){
      console.warn("No hay datos en la sesión");
      this.router.navigate(['/m/seguros/ups-error']);
    }
    this.prod = JSON.parse(sessionStorage.getItem('product'));
    this.daysInMonth = Array.from( Array( 31 ), (x, index) => index + 1 );
    this.months = Array.from( Array(12), (x, index) => index + 1 );
    this.years = new Array(93);
    for (let a = 1920, i = 0; a <= Number(moment().year()); a++, i++) {
      this.years[i] = a;
    }
    this.years.reverse();
    this._moment = moment;
   }

  ngOnInit() {

    this.totalViajeros = this.prod.vouchers.reduce((partial_sum, a) => partial_sum.quantity + Number(a.quantity));
    this.totalViajeros = typeof this.totalViajeros === 'object' ? this.totalViajeros.quantity : this.totalViajeros;
    this.totalNormal = this.prod.vouchers[0].quantity;
    this.totalIsic = this.prod.vouchers.length > 1 ? this.prod.vouchers[1].quantity : 0;

    this.typePassengers = [];
    for(let i = 0; i < this.totalNormal; i++){
      this.typePassengers.push(false);
    }
    for(let i = 0; i < this.totalIsic; i++){
      this.typePassengers.push(true);
    }

    this.form = this.fb.group({
      'passengerDataList': this.fb.array(this.createItem(this.totalViajeros)),
      'name': ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
      'lastName': ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
      'email': ['', [Validators.required, Validators.email, Validators.pattern(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)]],
      'mobile': ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]*$/)]],
      'phone': ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]*$/)]],
      'codePostal': ['', [Validators.required, Validators.pattern(/^[0-9]*$/)]],
      'name_em': ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
      'lastName_em': ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
      'phone_em': ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern(/^[0-9]*$/)]]
    });

    this.formPas = <FormArray>this.form.get('passengerDataList');

    this.form.get('passengerDataList').valueChanges.subscribe( data => {
      this.form.get('name').setValue(data[0].name);
      this.form.get('lastName').setValue(data[0].lastName);
    });
    this.form.get('mobile').valueChanges.subscribe( data => {
      this.form.get('phone').setValue(data);
    });

  }

  // tslint:disable-next-line: use-life-cycle-interface
  ngAfterViewInit() {
    $(document).ready(function () {
      $('html, body').animate({ scrollTop: 0 }, 'slow');
    });
  }

  get f() { return this.form.controls.passengerDataList; }


  createItem(viajeros: any) {
    const formArray = [];
    for (let index = 0; index < viajeros; index++) {

      const form = this.fb.group({
        name: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
        lastName: ['', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]],
        birthdayD: ['', [Validators.required]],
        birthdayM: ['', [Validators.required]],
        birthdayY: ['', [Validators.required]],
        gender: ['', [Validators.required]],
        isic: [this.typePassengers[index], []]
      });

      form.valueChanges.subscribe(data => {
        let dias;
        if (data.birthdayY !== '') {
          dias = moment(data.birthdayM>9?data.birthdayY+'-'+data.birthdayM:data.birthdayY+'-'+'0'+data.birthdayM, "YYYY-MM").daysInMonth();
        } else {
          dias = moment(data.birthdayM>9?data.birthdayM:'0'+data.birthdayM, "MM").daysInMonth();
        }
        if (form.value.birthdayD > dias) {
          form.controls.birthdayD.setValue('');
        }
      });

      formArray.push(form);

    }
    return formArray;
  }

  soloLetras(e){
    let key = e.keyCode || e.which;
    let tecla = String.fromCharCode(key).toLowerCase();
    let letras = " áéíóúabcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTWXYZ";
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for(var i in especiales){
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) ==- 1 && !tecla_especial) {
      return false;
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  removeAccents(str) {
    if (!str) {
      return '';
    }
    const accents = 'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž';
    const accentsOut = 'AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz';
    str = str.split('');
    str.forEach((letter, index) => {
      let i = accents.indexOf(letter);
      if (i != -1) {
        str[index] = accentsOut[i];
      }
    });
    return str.join('');
  }


  nextStep() {
    this.submitted = true;
    if (this.form.valid) {
      sessionStorage.setItem('passengerData', JSON.stringify(this.form.value));
      sessionStorage.setItem('totales', JSON.stringify({totalViajeros:this.totalViajeros, totalIsic: this.totalIsic, totalNormal: this.totalNormal}))
      this.flagActive = true;
    }
    this.buildGeneralDataLayer();
  }

  buildGeneralDataLayer() {
    const url = sessionStorage.getItem('url');
    const param_pair_string = url.split('&');
    const date_start = param_pair_string.filter(rep =>  rep.includes('dateFrom'));
    const departing_departure_date = date_start[0].split('=')[1].replace('%2', '').replace('F', '-').replace('%2F', '-');

    const date_end = param_pair_string.filter(rep =>  rep.includes('dateTo'));
    const returning_departure_date = date_end[0].split('=')[1].replace('%2', '').replace('F', '-').replace('%2F', '-');

    const data = {
      name: `${this.form.value.name} ${this.form.value.lastName}` ,
      id: this.prod.vouchers[0].productId,
      price: this.totalPay,
      departing_departure_date: departing_departure_date.split("-").reverse().join("-"),
      returning_departure_date: returning_departure_date.split("-").reverse().join("-"),
      content_type: 'insurance',
      currency: 'MXN',
      page_category: 'search',
      url_search: this.router.url,
      visitor_type: 'medium-value',
      product_name_insurances: this.prod.vouchers[0].productName,
      date_search: moment(new Date()).format('YYYY-MM-DD'),
      time_search: moment(new Date()).format('HH:mm')
    };

    window.dataLayer.push({
      'event': 'insurance_from_customer',
      'valData': data,
      'insurance_from_customer': data
    });
  }

  getCommission(totalPay) {
    this.totalPay = totalPay;
    const commission = {
      total: totalPay,
      dateFrom: this.prod.vouchers[0].dateFrom,
      dateTo: this.prod.vouchers[0].dateTo,
      country: 'mexico'
    };

    this.searchService.getCommission(commission).subscribe(
      response => {
        sessionStorage.setItem('commission', JSON.stringify(response));
      },
      error => {
        this.router.navigate(['/m/seguros/ups-error'])
      }
    );

  }

}
